/**
 * Pre-quiz participant details (tab-scoped). Not cleared by trp_* localStorage wipes.
 */
const PREFIX = 'certpro_registrant_v1_'

export function saveCertificationRegistrant(trackId, payload) {
  try {
    window.sessionStorage.setItem(
      `${PREFIX}${trackId}`,
      JSON.stringify({
        version: 1,
        name: String(payload.name || '').trim(),
        phone: String(payload.phone || '').trim(),
        email: String(payload.email || '').trim(),
        organisation: String(payload.organisation || '').trim()
      })
    )
  } catch {
    // ignore
  }
}

export function loadCertificationRegistrant(trackId) {
  try {
    const raw = window.sessionStorage.getItem(`${PREFIX}${trackId}`)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (data?.version !== 1) return null
    return {
      name: data.name || '',
      phone: data.phone || '',
      email: data.email || '',
      organisation: data.organisation || ''
    }
  } catch {
    return null
  }
}

export function clearCertificationRegistrant(trackId) {
  try {
    window.sessionStorage.removeItem(`${PREFIX}${trackId}`)
  } catch {
    // ignore
  }
}
